<div
  #menuContainer
  id="main-menu">
  <ng-container [ngTemplateOutlet]="matMenuTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="navListTemplate"></ng-container>
</div>

<ng-template #navListTemplate>
  <ul
    #navMenu
    [class.hide-menu]="showMatMenu()"
    class="app-menu-ul">
    @if (!isProvider) {
      <li class="item">
        <a
          matButton
          [routerLink]="['/']"
          class="link">
          Home
        </a>
      </li>
    }
    @for (item of items(); track item.label) {
      <li class="item">
        @if (item.subItems && item.subItems.length === 1) {
          @if (!item.subItems[0].requestUrl) {
            <a
              #rla="routerLinkActive"
              matButton
              [routerLink]="item.subItems[0].link | companyTypeBasedRoute"
              routerLinkActive="link_active"
              [ngClass]="premiumLabel === item.subItems[0].label ? 'premium-menu-item' : ''"
              [target]="item.subItems[0].target || '_self'"
              (click)="handleClick(item.subItems[0], $event)"
              class="link">
              <div class="flex align-center">
                @if (isUpgradeRequired | wrapFn: item.subItems[0]) {
                  <ume-lock-icon class="m-r-quoter"></ume-lock-icon>
                }
                <span class="menu-label">{{ item.subItems[0].name }}</span>
              </div>
            </a>
          }

          @if (item.subItems[0].requestUrl) {
            <button
              mat-menu-item
              class="link"
              (click)="handleClick(item.subItems[0], $event)">
              <div class="flex align-center">
                <span class="menu-label">
                  {{ item.subItems[0].name }}
                </span>
                @if (isUpgradeRequired | wrapFn: item.subItems[0]) {
                  <ume-lock-icon class="m-r-quoter"></ume-lock-icon>
                }
              </div>
            </button>
          }
        }
        @if (item.subItems && item.subItems.length > 1) {
          @let isUpgradeNeeded = isAllSubItemsRequireUpgrade | wrapFn: item.subItems;
          <button
            matButton
            (click)="isUpgradeNeeded ? handleClick(item.subItems[0], $event) : null"
            [matMenuTriggerFor]="isUpgradeNeeded ? null : submenu.menu()"
            class="link">
            <span class="inner-button-container">
              @if (isUpgradeNeeded) {
                <ume-lock-icon class="m-r-quoter"></ume-lock-icon>
              }

              <span class="menu-label">{{ item.name }}</span>
              @if (!isUpgradeNeeded) {
                <mat-icon>expand_more</mat-icon>
              }
            </span>
          </button>
          <ume-main-nav-menu-panel
            #submenu
            [items]="item.subItems"></ume-main-nav-menu-panel>
        }
      </li>
    }
  </ul>
</ng-template>

<ng-template #matMenuTemplate>
  <div
    [class.hide-menu]="!showMatMenu()"
    class="trigger-content">
    @if (!isProvider) {
      <a
        matButton
        [routerLink]="['/']"
        class="link">
        Home
      </a>
    }

    <button
      matButton
      [matMenuTriggerFor]="menu">
      <mat-icon class="mat-18">menu</mat-icon>
      Menu
    </button>
  </div>

  <mat-menu
    #menu="matMenu"
    role="menu">
    @if (items().length) {
      @for (item of items(); track item.label) {
        @if (item.subItems && item.subItems.length === 1) {
          @if (!item.subItems[0].requestUrl) {
            <a
              mat-menu-item
              [target]="item.subItems[0].target || '_self'"
              routerLinkActive="link_active"
              class="link"
              [ngClass]="premiumLabel === item.subItems[0].label ? 'premium-menu-item' : ''"
              [routerLink]="item.subItems[0].link | companyTypeBasedRoute"
              (click)="handleClick(item.subItems[0], $event)">
              <div class="flex align-center">
                <span class="menu-label text-capitalize">{{ item.subItems[0].name }}</span>
                @if (isUpgradeRequired | wrapFn: item.subItems[0]) {
                  <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
                }
              </div>
            </a>
          }

          @if (item.subItems[0].requestUrl) {
            <button
              mat-menu-item
              class="link"
              (click)="handleClick(item.subItems[0], $event)">
              <div class="flex align-center">
                <span class="menu-label">{{ item.subItems[0].name }}</span>
                @if (isUpgradeRequired | wrapFn: item.subItems[0]) {
                  <ume-lock-icon class="m-r-quoter"></ume-lock-icon>
                }
              </div>
            </button>
          }
        }

        @if (item.subItems && item.subItems.length > 1) {
          @let isAllSubItemNotUpgraded = isAllSubItemsRequireUpgrade | wrapFn: item.subItems;

          <button
            mat-menu-item
            (click)="isAllSubItemNotUpgraded ? handleClick(item.subItems[0], $event) : null"
            [matMenuTriggerFor]="isAllSubItemNotUpgraded ? null : submenu.menu()"
            [class.disabled]="isAllSubItemNotUpgraded"
            class="link text-capitalize">
            <div class="flex align-center">
              <span class="menu-label text-capitalize">{{ item.name }}</span>
              @if (isUpgradeRequired | wrapFn: item.subItems[0]) {
                <ume-lock-icon class="m-l-quoter"></ume-lock-icon>
              }
            </div>
          </button>
          <ume-main-nav-menu-panel
            #submenu
            [items]="item.subItems"></ume-main-nav-menu-panel>
        }
      }
    }
  </mat-menu>
</ng-template>
